import React from "react";
import { Outlet } from "react-router-dom";

function Clients() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default Clients;
